module.exports = __webpack_public_path__ + "static/media/b2c-image-taobao.d6d94209.png";